import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3350c31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "div"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-cd" }, null, -1))
const _hoisted_3 = {
  key: 0,
  for: "fileInput"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "div"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-cd" }, null, -1))
const _hoisted_10 = {
  key: 0,
  for: "fileInput"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_drive_add_files = _resolveComponent("drive-add-files")!
  const _component_drive_add_menu_pop_up = _resolveComponent("drive-add-menu-pop-up")!
  const _component_drive_desktop_add_files = _resolveComponent("drive-desktop-add-files")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
              key: 0,
              onHide: _ctx.hidePopUp,
              "hide-bottom-decoration": "",
              "hide-top-decoration": "",
              class: "popUp-fixed"
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.title')), 1)
              ]),
              body: _withCtx(() => [
                _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openAddPhotos }, {
                  icon: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_4
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 1,
                      for: "fileInput",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.GALLERY)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_5
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.gallery')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 2,
                      for: "fileInput",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "fileInput",
                  ref: "fileInput",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadFiles($event))),
                  type: "file",
                  multiple: "",
                  style: {"visibility":"hidden"}
                }, null, 544), [
                  [_vShow, false]
                ]),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                      key: 3,
                      onClick: _withModifiers(_ctx.flutterOpenFilePicker, ["prevent"]),
                      "data-type": "flutter"
                    }, {
                      icon: _withCtx(() => [
                        _hoisted_7
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onHide"]))
          : _createCommentVNode("", true),
        (_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_drive_add_files, {
              key: 1,
              onClose: _ctx.closeAddPhotos
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        (!_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_drive_add_menu_pop_up, {
              key: 0,
              onHide: _ctx.hidePopUp,
              desktopPopUpPosition: _ctx.filesPopUpPos,
              "hide-bottom-decoration": "",
              "hide-top-decoration": ""
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.title')), 1)
              ]),
              body: _withCtx(() => [
                _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openAddPhotos }, {
                  icon: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_ctx.mainStore.isAndroid)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 1,
                      for: "fileInput",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.GALLERY)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_12
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.gallery')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 2,
                      for: "fileInput",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_13
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("input", {
                  id: "fileInput",
                  ref: "fileInput",
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.uploadFiles($event))),
                  type: "file",
                  multiple: "",
                  style: {"visibility":"hidden"}
                }, null, 544)
              ]),
              _: 1
            }, 8, ["onHide", "desktopPopUpPosition"]))
          : _createCommentVNode("", true),
        (_ctx.isAddFilesPopUp)
          ? (_openBlock(), _createBlock(_component_drive_desktop_add_files, {
              key: 1,
              onClose: _ctx.closeAddPhotos
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
}